// @flow
import {
  COOKIE_ALL_ACCEPTED_STATE,
  COOKIE_SETTINGS_STORAGE_KEY
} from './consts'

export const getSavedCookieSettings = () => {
  try {
    const savedSettings = window.localStorage.getItem(
      COOKIE_SETTINGS_STORAGE_KEY
    )

    return savedSettings
      ? { ...COOKIE_ALL_ACCEPTED_STATE, ...JSON.parse(savedSettings) }
      : COOKIE_ALL_ACCEPTED_STATE
  } catch (error) {
    return COOKIE_ALL_ACCEPTED_STATE
  }
}
